/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OperatingHours } from './operatingHours';


export interface StatusCodeValueOperatingHours { 
    value?: OperatingHours;
    status_code?: number;
}

